export enum NotificationFeedbackType {
  UNREACHABLE = 'unreachable',
  TO_BE_CONTINUED = 'to_be_continued',
  APPOINTMENT_SCHEDULED = 'appointment_scheduled',
  NOTHING_TO_DO = 'nothing_to_do',
}

export const notificationFeedbackTypeAsString = (
  type: NotificationFeedbackType | string
): string => {
  switch (type) {
    case NotificationFeedbackType.UNREACHABLE:
      return "Injoignable";
    case NotificationFeedbackType.TO_BE_CONTINUED:
      return "À suivre";
    case NotificationFeedbackType.APPOINTMENT_SCHEDULED:
      return "RDV obtenu";
    case NotificationFeedbackType.NOTHING_TO_DO:
      return "Ne pas donner suite";
    default:
      return "❌ Type de notificationFeedback non reconnu";
  }
};

export const notificationFeedbackTypeAsColor = (
  type: NotificationFeedbackType | string
): string => {
  switch (type) {
    case NotificationFeedbackType.UNREACHABLE:
      return "#ffb3b3";
    case NotificationFeedbackType.TO_BE_CONTINUED:
      return "#b3d2ff";
    case NotificationFeedbackType.APPOINTMENT_SCHEDULED:
      return "#3EBEA8";
    case NotificationFeedbackType.NOTHING_TO_DO:
      return "#d2d2d2";
    default:
      return "#d2d2d2";
  }
};
